import _ from "lodash";
import moment from "moment";
import react, { useState } from "react";
import { useEffect } from "react";
import { TableControl } from "../../../../../components/controls";
import { asyncForEach } from "../../../../contentLibrary/utils/jsUtil";
import { FormatUTCDate } from "../../../../../utilities/DateFormater";
import {
  FormatFileSize,
  FormatRuntime,
} from "../../../../../utilities/FileFormatter";

const VirtualLibrarianAvailableContentTable = ({
  filteredItems,
  onEdit,
  onDelete,
}) => {
  const [rows, setRows] = useState([]);
  const [columns] = useState([
    {
      header: "Title",
      dataProp: "title",
      width: "20%",
      canSort: true,
    },
    {
      header: "Type",
      dataProp: "resource",
      width: "10%",
      canSort: true,
    },
    {
      header: "Extension",
      dataProp: "extension",
      width: "10%",
      canSort: true,
    },
    {
      header: "File Size",
      dataProp: "filesize",
      width: "10%",
      canSort: true,
    },
    {
      header: "Run Time",
      dataProp: "runtime",
      width: "9%",
      canSort: true,
    },
    {
      header: "OK for Content Library",
      dataProp: "hidefromlibrary",
      width: "10%",
      canSort: true,
      datatype: "bool",
      isBool: true,
    },
    {
      header: "OK for ECHO Admin",
      dataProp: "isaiadmin",
      width: "9%",
      canSort: true,
      datatype: "bool",
      isBool: true,
    },
    {
      header: "OK for ECHO Users",
      dataProp: "isai",
      width: "9%",
      canSort: true,
      datatype: "bool",
      isBool: true,
    },
    // {
    //   header: "AiStatus",
    //   dataProp: "aiStatus",
    //   width: "8%",
    //   canSort: true,
    // },
  ]);

  useEffect(() => {
    if (filteredItems) {
      const updatedItems = filteredItems.map((item) => {
        return {
          ...item,
          filesize: FormatFileSize(item?.filesize),
          runtime: FormatRuntime(item?.runtime),
        };
      });
      setRows([...updatedItems]);
    }
  }, [filteredItems]);

  return (
    <div className="vl-content-wrapper">
      <div className="table-container">
        <div className="table-container-inner">
          <TableControl
            columns={columns}
            permission="Tag"
            data={rows}
            useIntegratedPaging={["10", "25", "50", "100"]}
            onEdit={(row) => onEdit(row.content_id)}
            onDelete={onDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default VirtualLibrarianAvailableContentTable;
